import React, {
    useEffect, useRef, useState
} from 'react';
import './index.scss';
import ArticleHeader from '../../components/ArticleHeader/';
import Discount from '../../components/Discounts/';
import HotProduct from '../../components/HotProducts';
import RecommendProduct from '../../components/RecommendProduct'
import Comment from '../../components/Comment'
// import BottomInput from '../../components/BottomInput'
import RecommendArticles from '../../components/RecommendArticles';
import LoadingContent from '../../components/Loading'
import articleDetail from '../../service/articleDetail';
import utils from 'bxl-utils';
// import ShareBottom from '../../components/ShareBottom';
import QuoteInfo from '../../components/QuoteInfo/';
import { openAppStore } from '@/lib/appstore';
import { isBrowser } from '@/lib/utils';
import Seo from '@/templates/seo'

function ArticleDetail(props) {
    const { id, pageContext } = props || {}
    const [article, setArticle] = useState(() => {
        return pageContext?.article
    })
    const [commentType, setCommentType] = useState('postedAt')
    const [commentsTotal, setCommentsTotal] = useState(() => {
        return pageContext?.comment
    })
    const [relatedArticles, setRelatedArticles] = useState(() => {
        return pageContext?.relatedArticles
    })
    const [pageNo, setPageNo] = useState(1)
    const [loading, setLoading] = useState(false)
    const firstRender = useRef(true)
    const {
        header,
        discounts,
        meta,
        recommendations,
        hotProducts,
        footer
    } = article || {}
    let nextCommentsThrottled = nextComments
    useEffect(() => {
        if (!isBrowser) return
        nextCommentsThrottled = utils?.throttle(500, nextComments)
    }, [])

    useEffect(() => {
        if (!isBrowser) return
        if (id && !pageContext?.article) {
            setLoading(true)
            articleDetail.getArticleDetail(id)
                .then(res => {
                    // wx_share({
                    //     icon: res.header.image,
                    //     title: res.header.title,
                    // })
                    setArticle(res)
                    refreshProductsInfo(res)
                    setLoading(false)
                })
                .catch(error => {
                    console.error(error);
                    setLoading(false)
                })
        } else if (pageContext?.article) {
            refreshProductsInfo(pageContext?.article)
        }

        if (!pageContext?.relatedArticles?.length) {
            getRelatedArticles(id)
        }

        window?.addEventListener('scroll', getMoreComment)
        return () => {
            window?.removeEventListener('scroll', getMoreComment)
        }
    }, [id, pageContext])

    const getMoreComment = () => {
        if (!isBrowser) return
        let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
        let totalHeigth = document.body.scrollHeight || document.documentElement.scrollHeight
        let scrollHeight = document.body.scrollTop || document.documentElement.scrollTop

        if (clientHeight + scrollHeight === totalHeigth) {
            nextCommentsThrottled && nextCommentsThrottled()
        }
    }

    useEffect(() => {
        if (pageNo === 1 && firstRender.current && pageContext?.comment) return
        getComments()
    }, [id, pageContext, pageNo, commentType])

    useEffect(() => {
        firstRender.current = false
    }, [])

    const nextComments = () => {
        const total = commentsTotal?.total || 0
        if (pageNo * 10 >= total) {
            return
        }
        setPageNo(pageNo + 1)
    }

    //获取评论
    const getComments = () => {
        if (!id) return

        articleDetail.getArticleComments({
            articleId: id,
            pageNo: pageNo,
            type: commentType
        }).then(res => {
            if (pageNo === 1) {
                setCommentsTotal(res)
            } else {
                const newComment = Object.assign({}, commentsTotal)
                newComment.comments = newComment.comments.concat(res.comments)
                setCommentsTotal(newComment)
            }
        }).catch(error => {
            console.error(error);
        })
    }

    /**
     * 获取相关文章
     */
    const getRelatedArticles = (articleId) => {
        if (articleId) {
            articleDetail.getRelatedArticles(articleId)
                .then(res => {
                    if (res?.length) {
                        setRelatedArticles(res)
                    }
                })
                .catch(error => {})
        }
    }

    const refreshProductsInfo = (article) => {
        if (!article) return
        const ids = [];
        if (article.discounts && article.discounts.contents) {
            article.discounts.contents.forEach((item, index) => {
                if (item.imageButton && item.imageButton.productID) {
                    ids.push(item.imageButton.productID);
                }
            });
        }
        if (article.recommendations && article.recommendations.contents) {
            article.recommendations.contents.forEach((item, index) => {
                if (item.productID) {
                    ids.push(item.productID);
                }
            });
        }

        if (article.hotProducts && article.hotProducts.contents) {
            article.hotProducts.contents.forEach((item, index) => {
                if (item.productID) {
                    ids.push(item.productID)
                }
            })
        }
        if (ids.length === 0) {
            return;
        }
        articleDetail.getProductsByIds(ids)
            .then(res => {
                if (!res.length) {
                    return
                }
                const products = res.map(p => {
                    return {
                        origin: p.origin,
                        merchantName: p.merchantName,
                        favoritedCount: p.favoritedCount || 0,
                        activityOffs: p.activityOffs,
                        off: p.off,
                        ...p.product,
                    }
                })
                const productMaps = {};
                products.forEach(p => {
                    productMaps[p.id] = p;
                })
                const newArticle = Object.assign({}, article);

                if (newArticle.discounts && newArticle.discounts.contents) {
                    newArticle.discounts.contents.forEach((item, index) => {
                        if (item.imageButton && item.imageButton.productID) {
                            item.imageButton.price = productMaps[item.imageButton.productID] ? productMaps[item.imageButton.productID].priceTag : '';
                        }
                    });
                }

                if (newArticle.recommendations && newArticle.recommendations.contents) {
                    newArticle.recommendations.contents.forEach((item, index) => {
                        if (productMaps[item.productID]) {
                            item.productInfo = productMaps[item.productID]
                        } else {
                            let priceCN = item.originalPrice && item.originalPrice.split(' ')[1].slice(2) || '未知';
                            let obj = {
                                id: item.productID,
                                priceTag: item.originalPrice && item.originalPrice.split(' ')[0] || '未知',
                                priceTagCN: priceCN.slice(0, priceCN.length - 1)
                            }
                            item.productInfo = obj
                        }
                    });
                }

                if (newArticle.hotProducts && newArticle.hotProducts.contents) {

                    newArticle.hotProducts.contents.forEach((item, index) => {
                        if (productMaps[item.productID]) {
                            item.productInfo = productMaps[item.productID]
                        } else {
                            let priceCN = item.originalPrice && item.originalPrice.split(' ')[1] && item.originalPrice.split(' ')[1].slice(2) || '未知';
                            let obj = {
                                priceTag: item.originalPrice && item.originalPrice.split(' ')[0] || '未知',
                                priceTagCN: priceCN.slice(0, priceCN.length - 1)
                            }
                            item.productInfo = obj
                        }
                    });
                }
                setArticle(newArticle)
            })
            .catch(error => {
                console.error(error);
            })
    }

    const toAppPage = (path) => {
        openAppStore()
    }

    const likeComment = (info) => {
        openAppStore()
    }

    const clickToComment = (commentInfo) => {
        openAppStore()
    }

    const toSecondComment = (commentId) => {
        openAppStore()
    } 

    const clickHash = (value) => {
        openAppStore()
    }

    const changeCommentType = (e) => {
        if (e && e !== commentType) {
            setCommentType(e)
            setPageNo(1)
        }
    }

    const renderRecommentations = (recommendations) => {
        if (!recommendations || !recommendations.contents || recommendations.contents.length === 0) {
            return null
        }

        const {
            title,
            contents
        } = recommendations
        return (
            <section className='recommendProductBox'>
                <div className='recommendTitleBox'>
                    <span className='spot'></span>
                    <span className='spot'></span>
                    <h2 className='recommendTitle'>{title || '推荐商品'}</h2>
                    <span className='spot spot3'></span>
                    <span className='spot'></span>
                </div>
                {
                    contents.map((item, index) => (item.itemType === 'recommendation' && item.productID) ? 
                        (
                            <RecommendProduct
                                key={'recommendItem_' + index}
                                index={index}
                                content={item}
                            />
                        ) : 
                        (
                            <div key={'recommendItem_' + index} className='recommend_quote'>
                                {item.text ? (
                                    <QuoteInfo data={item.text}></QuoteInfo>
                                ) : null}
                            </div>
                        )
                    )
                }
            </section>
        )
    }

    const getFirstContentText = () => {
        if (header?.text) return header.text
        if (!discounts || !discounts?.contents?.length) return header?.title || ''
        const firstContentWithText = discounts.contents.find(c => !!c.text)
        if (!firstContentWithText) {
            return header?.title || ''
        }
        return firstContentWithText.text
    }

    const getKeywords = () => {
        const keywords = new Set()
        if (header?.hashtags?.length) {
            header?.hashtags.forEach(tag => {
                keywords.add(tag)
            })
        }
        if (keywords.size < 5 && recommendations?.contents?.length) {
            recommendations.contents.slice(0, 3).forEach(content => {
                if (content.title1) {
                    keywords.add(content.title1)
                }
                if (content.title2) {
                    keywords.add(content.title2)
                }
            })
        }
        if (keywords.size < 5 && hotProducts?.contents?.length) {
            hotProducts.contents.slice(0, 3).forEach(content => {
                if (content.title1) {
                    keywords.add(content.title1)
                }
                if (content.title2) {
                    keywords.add(content.title2)
                }
            })
        }
        return Array.from(keywords).join(', ')
    }

    return (
        <div className='article_container'>
            <Seo
                title={`${header?.title || ''}${header?.subtitle || ''}_别样海外购`}
                description={`别样海外购 ${meta?.authorLabel ? `作者${meta?.authorLabel}, ` : ''}${getFirstContentText()}`}
                keywords={`${getKeywords()}, 别样 App, 别样海外购, Bieyang App, 别样海淘`}
            />
            <ArticleHeader header={header} meta={meta} />
            {
                discounts ? <Discount discounts={discounts} toAppPage={toAppPage}></Discount> : null
            }
            <div className='hashTagContent'>
                {
                    header?.hashtags?.length ? header.hashtags.map((item, index) => {
                        return (
                            <div className='hashTag' key={'item' + index} onClick={e => { clickHash(item) }}>
                                {item}
                            </div>
                        )
                    }) : null
                }
            </div>
            {
                renderRecommentations(recommendations)
            }
            {
                hotProducts?.contents?.length ? (
                    <HotProduct products={hotProducts} lookMoreLink={footer.link} footer={footer} />
                ) : null
            }
            {
                relatedArticles?.length ? <RecommendArticles data={relatedArticles} /> : null
            }
            <Comment
                toSecondComment={toSecondComment} 
                comments={commentsTotal?.comments || []}
                likeComment={likeComment}
                commentType={commentType}
                clickToComment={clickToComment}
                total={+commentsTotal?.total || 0} 
                changeCommentType={changeCommentType}
            ></Comment>
            {
                loading ? <LoadingContent text={''}></LoadingContent> : null
            }
        </div>
    )
}

export default ArticleDetail
